const workspaceViewKey = 'relay.workspace-view';
export const workspaceViewToken = () => sessionStorage.getItem(workspaceViewKey);
export function setWorkspaceView(token: string | null) {
  if (token) sessionStorage.setItem(workspaceViewKey, token); else sessionStorage.removeItem(workspaceViewKey);
}
export class ApiError extends Error {
  constructor(message: string, status: number, public code: string) { super(message); this.name = String(status); }
}
export async function api<T>(path: string, body?: unknown, method?: string, signal?:AbortSignal): Promise<T> {
  const view = workspaceViewToken();
  const response = await fetch(`/api${path}`, {
    method: method ?? (body === undefined ? 'GET' : 'POST'), credentials: 'same-origin',signal,
    headers: { ...(body === undefined ? {} : { 'Content-Type': 'application/json' }), ...(view ? { 'X-Relay-Workspace-View': view } : {}) },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const result = await response.json();
  if (view !== workspaceViewToken()) throw new ApiError('The workspace view changed.', 409, 'workspace_view_changed');
  if (!response.ok) { const message = result && typeof result === 'object' && 'error' in result ? String(result.error) : 'Request failed.'; throw new ApiError(message, response.status, result && typeof result === 'object' && 'code' in result ? String(result.code) : 'request_failed'); }
  return result as T;
}
export const money = (n: number) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);
export const time = (s: string | null) => s ? new Date(s).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : '—';
export const initials = (name: string) => name.split(' ').map(p => p[0]).slice(0, 2).join('');
